<script lang="ts" setup>
  import { useQidianService } from '@/composable'
  import { BtnType, ColorType } from '@/define'
  import { getAssetsFile } from '@/utils'
  import BaseBtn from '@components/btn/BaseBtn.vue'
  import CarouselCase from '@components/carousel/CarouselCase.vue'

  const unitFilter = (value: string) => {
    const lastStr = value.charAt(value.length - 1)
    return isNaN(Number(lastStr)) ? lastStr : ''
  }

  const tabList = [
    {
      key: 1,
      checkImg: getAssetsFile('case/case-game-logo-check_1.png'),
      noCheckImg: getAssetsFile('case/case-game-logo_1.png'),
    },
    {
      key: 2,
      checkImg: getAssetsFile('case/case-game-logo-check_2.png'),
      noCheckImg: getAssetsFile('case/case-game-logo_2.png'),
    },
    {
      key: 3,
      checkImg: getAssetsFile('case/case-game-logo-check_4.png'),
      noCheckImg: getAssetsFile('case/case-game-logo_4.png'),
    },
    {
      key: 4,
      checkImg: getAssetsFile('case/case-game-logo-check_3.png'),
      noCheckImg: getAssetsFile('case/case-game-logo_3.png'),
    },
    {
      key: 5,
      checkImg: getAssetsFile('case/case-game-logo-check_5.png'),
      noCheckImg: getAssetsFile('case/case-game-logo_5.png'),
    },
  ]
  const slideList = [
    {
      logo: [getAssetsFile('case/case-game-logo_1.png')],
      brandName: 'A1零食研究所',
      title: '糕颜值挑战',
      tag: ['粉丝活跃'],
      content: '爱逸三八节档在社群发布跳跃类互动小游戏，游戏中植入糕点等产品元素，节点营销氛围浓厚',
      phoneImg: getAssetsFile('customize/game-case-banner_1.jpg'),
      data: [
        {
          total: '72.8w',
          name: '新用户回访率',
          precision: 1,
        },
        {
          total: '52.6%',
          name: '新增阅读转化',
          precision: 1,
        },
        {
          total: '29.7%',
          name: '分享率',
          precision: 1,
        },
      ],
    },
    {
      logo: [getAssetsFile('case/case-game-logo_2.png'), getAssetsFile('case/case-game-logo_4.png')],
      brandName: '鸿星尔克 ✕ 盼盼',
      title: '鸿运上上签&好运上上签',
      tag: ['品牌传播', '裂变引流'],
      content:
        '鸿星尔克&昐盼在春节期间进行的跨界联盟互动(抽签)，将两个品牌的流量进行置换，成功实现异业品牌间的奖券互派及核销转化',
      phoneImg: getAssetsFile('customize/game-case-banner_2.jpg'),
      data: [
        {
          total: '55.2w',
          name: '裂变新增流量',
          precision: 1,
        },
        {
          total: '43.6%',
          name: '新增阅读转化',
          precision: 1,
        },
        {
          total: '47.2%',
          name: '会员券核销率',
          precision: 1,
        },
      ],
    },
    {
      logo: [getAssetsFile('case/case-game-logo_4.png'), getAssetsFile('case/case-game-logo_2.png')],
      brandName: '盼盼✕ 鸿星尔克',
      title: '好运上上签&鸿运上上签',
      tag: ['品牌传播', '裂变引流'],
      content:
        '鸿星尔克&昐盼在春节期间进行的跨界联盟互动(抽签)，将两个品牌的流量进行置换，成功实现异业品牌间的奖券互派及核销转化',
      phoneImg: getAssetsFile('customize/game-case-banner_3.jpg'),
      data: [
        {
          total: '55.2w',
          name: '裂变新增流量',
          precision: 1,
        },
        {
          total: '43.6%',
          name: '新增阅读转化',
          precision: 1,
        },
        {
          total: '47.2%',
          name: '会员券核销率',
          precision: 1,
        },
      ],
    },
    {
      logo: [getAssetsFile('case/case-game-logo_4.png')],
      brandName: '安井',
      title: '早餐向前冲',
      tag: ['会员新增'],
      content: '搭积木类游戏，结合安井各系列产品，用户在沉浸游戏的同时，对品牌产品快速形成记忆',
      phoneImg: getAssetsFile('customize/game-case-banner_4.jpg'),
      data: [
        {
          total: '49.2%',
          name: '裂变新增流量',
          precision: 1,
        },
        {
          total: '70.4%',
          name: '粉丝活跃增长',
          precision: 1,
        },
        {
          total: '32.5%',
          name: '首购付款率',
          precision: 1,
        },
      ],
    },
    {
      logo: [getAssetsFile('case/case-game-logo_5.png')],
      brandName: '韩菲诗',
      title: '跨越山海宠爱你',
      tag: ['会员新增'],
      content: '韩菲诗情人节档在公众号渠道发布的跳跃类互动小游戏，将企业IP植入唯美轻松的游戏',
      phoneImg: getAssetsFile('customize/game-case-banner_5.jpg'),
      data: [
        {
          total: '55.2%',
          name: '新用户回访率',
          precision: 1,
        },
        {
          total: '83.4%',
          name: '会员参与激活率',
          precision: 1,
        },
        {
          total: '60%',
          name: '入会率',
          precision: 0,
        },
      ],
    },
  ]

  const { onServiceClick, loading } = useQidianService()
</script>

<template>
  <carousel-case :tab-list="tabList" v-slot="slotProps" :height="680">
    <div class="game-carousel">
      <div class="left-box">
        <div class="header">
          <div v-for="logo in slideList[slotProps.index]?.logo" class="header-logo" :key="logo">
            <img :src="logo" />
          </div>
          <span class="header-name">{{ slideList[slotProps.index]?.brandName }}</span>
        </div>
        <div class="main">
          <div class="main-top">
            <span class="main-title">{{ slideList[slotProps.index]?.title }}</span>
            <span v-for="tag in slideList[slotProps.index]?.tag" :key="tag" class="main-tag">{{ tag }}</span>
          </div>
          <div class="main-middle">
            <div class="main-content">{{ slideList[slotProps.index]?.content }}</div>
          </div>
          <div class="main-data">
            <div v-for="item in slideList[slotProps.index]?.data" :key="item.name" class="data-item">
              <div class="item-num">
                <a-statistic
                  class="num"
                  :value="Number(item.total.substring(0, item.total.length - 1))"
                  :precision="item.precision"
                  :value-from="0"
                  :start="true"
                  animation
                ></a-statistic>
                <span class="unit">{{ unitFilter(item.total) }}</span>
              </div>
              <div class="item-name">{{ item.name }}</div>
            </div>
          </div>
          <div class="btn">
            <base-btn
              :loading="loading"
              id="dxhd_customer_service"
              :type="BtnType.SHOW"
              :color="ColorType.PRIMARY"
              @click="onServiceClick"
              >立即咨询</base-btn
            >
          </div>
        </div>
      </div>
      <div class="right-box">
        <img src="@images/case/phone-bg.png" class="phone" />
        <div class="content">
          <img :src="slideList[slotProps.index]?.phoneImg" />
        </div>
      </div>
    </div>
  </carousel-case>
</template>

<style lang="less" scoped>
  :deep(.carousel-item) {
    align-items: center;
  }

  :deep(.tab-box) {
    margin-bottom: 40px !important;
  }

  :deep(.carousel-indicator) {
    margin-top: 0;
    margin-left: 30px;
  }

  .game-carousel {
    position: relative;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    height: 565px;
    margin: 0 30px;
    padding-top: 60px;
    padding-left: 100px;
    border-radius: 10px;
    box-shadow: 0 8px 20px 0 rgb(161 178 219 / 30%);

    .left-box {
      width: 540px;

      .header {
        display: flex;
        align-items: center;
        margin-bottom: 33px;

        .header-logo {
          width: 40px;
          height: 40px;
          margin-right: 12px;
          overflow: hidden;
          border-radius: 4px;
          box-shadow: 0 0 30px 0 rgb(161 178 219 / 30%);

          img {
            width: 100%;
            height: 100%;
          }
        }

        .header-name {
          color: @black;
          font-weight: 500;
          font-size: 26px;
          font-family: PingFangSC-Medium, 'PingFang SC', sans-serif;
          line-height: 37px;
        }
      }

      .main {
        .main-top {
          display: flex;
          align-items: center;
          margin-bottom: 13px;

          .main-title {
            margin-right: 8px;
            color: @black;
            font-weight: 600;
            font-size: 30px;
            font-family: PingFangSC-Semibold, 'PingFang SC', sans-serif;
            line-height: 42px;
          }

          .main-tag {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 72px;
            height: 28px;
            margin-right: 8px;
            color: @primary-color;
            font-size: 14px;
            font-family: PingFangSC-Regular, 'PingFang SC', sans-serif;
            background: #e8f0fc;
            border-radius: 2px;
          }
        }

        .main-middle {
          margin-bottom: 40px;
          color: #3d485d;
          font-size: 16px;
          font-family: PingFangSC-Regular, 'PingFang SC', sans-serif;
          line-height: 28px;
        }

        .main-data {
          display: flex;
          margin-bottom: 40px;

          .data-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 160px;
            height: 121px;
            margin-right: 30px;
            background: #e8f0fc;
            border-radius: 5px;

            .item-num {
              display: flex;
              align-items: baseline;
              color: @primary-color;

              .num {
                margin-right: 4px;

                :deep(.arco-statistic-value) {
                  color: @primary-color;
                  font-weight: 500;
                  font-size: 40px;
                  font-family: Oswald-Medium, Oswald, sans-serif;
                  line-height: 60px;

                  .arco-statistic-value-integer,
                  .arco-statistic-value-decimal {
                    font-size: 40px;
                  }
                }
              }

              .unit {
                font-size: 16px;
              }
            }

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }

    .right-box {
      position: absolute;
      top: -43px;
      right: 120px;
      z-index: 10;
      width: 320px;
      height: 648px;

      img {
        width: 100%;
        height: 100%;
      }

      .phone {
        position: absolute;
        z-index: 10;
      }

      .content {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1;
        width: 286px;
        height: 618px;
        overflow: hidden;
        transform: translate(-50%, -50%);

        img {
          width: 100%;
          height: 100%;
        }

        .qrcode {
          position: absolute;
          bottom: 0;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 0;
          overflow: hidden;
          backdrop-filter: blur(10px);
          transition: all ease 0.5s;

          img {
            width: 100px;
            height: 100px;
          }
        }
      }

      &:hover {
        .qrcode {
          height: 153px;
        }
      }
    }
  }
</style>
